// 创建订单
// http://api.umucdn.cn/project/216/interface/api/3040
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { PRODUCT_TYPE } from '@umu/umu-types';

export interface IInput {
    product_id: string; // 商品ID
    subject: string; // 商品名称
    amount: string; // 商品价格，单位分
    product_config: string; // 商品配置(json)
    body?: string; // 商品描述，非必须
    product_type?: PRODUCT_TYPE;
    seller_id?: string;
}

export interface IOutput {
    out_trade_no: string; // "U202003281935001523433",
    product_subject: string; // "hahah",
    umu_id: string; // "42712",
    product_amount: string; // 109,
    pay_amount: number; // 109,
    product_desc: string; // "",
    product_id: string; // "123",
    pay_mode: number; // 1,
    status: number; // 0,
    create_time: number; /// 1585395300,
    update_time: number; // 1585395300,
    id: string; // "26"
}

export const createOrder = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PAYMENT_CREATE_ORDER, data).then((res: IResponse<IOutput>) => res);
};
